const log = (message: string, data?: any) => {
    const appName = process.env.REACT_APP_APP_NAME;
  
    if (appName === "app-dev" || appName === "app-staging") {
      if (data !== undefined) {
        console.log(message, data);
      } else {
        console.log(message);
      }
    }
  };
  
  export default log;